import { Artwork, Badge, Base, Button, Column, FocusManager, NavigationManager, ProgressBar, ScrollWrapper, withSelections } from "@lightningjs/ui-components";
import EpgChannel from "../epg-channel";
import EPGManager from "../epg-model";
import EPGRowUI from "./epg-row-ui";
import EPGUtility from "../epg-utility";
import EPGProgramUI from "./epg-program-ui";
import EPGConfig from "../epg-config";
import { getImage } from "../../../models/data-service";
import { Img } from "@lightningjs/sdk";
import { Helper } from "../../../helper";
import EPGTimeRowUI from "./epg-time-row-ui";

export default class EPGGuide extends Base<Base.TemplateSpec> {
    [x: string]: any;

    epgChannelCreated = false;
    prevIndex = -1
    timestamp = 0;
    imageUpdateId = null;
    _imgUrl = '';
    autoHideId;
    autoHideTime = 60 * 3 * 1000; //autohide timer set for 3 minutes.
    focusTime!: Date

    static override _template() {
        return {
            w: (w: number) => w,
            h: (h: number) => h,
            rect: true,
            color: 0xff393C45,
            Info: {
                w: 1080,
                h: 250,
                flex: { margin: 0 },
                Image: {
                    w: 448,
                    h: 250,
                    Img: undefined
                },
                InfoContainer: {
                    x: 20,
                    flex: { direction: 'column' },
                    Title: { text: { text: 'Title', fontSize: 36, wordWrapWidth: 1200, maxLines: 1, maxLinesSuffix: '...', textOverflow: 'ellipsis' }, color: 0xffffffff },
                    ItemMetadataWrapper: {
                        flex: { direction: 'row', alignItems: 'flex-end', wrap: false },
                        rect: true, color: 0x00000000,
                        ProgressWrapper: {
                            w: 366,
                            h: 60,
                            flex: { direction: 'column' },
                            TimeWrapper: {
                                w: (w: number) => w,
                                h: 50,
                                flex: { padding: 0, justifyContent: 'space-between', alignItems: 'center' },
                                ProgStartTime: {
                                    h: 30,
                                    text: { text: '00:00:00', fontSize: 24, fontFace: "Light" }
                                },
                                ProgEndTime: {
                                    h: 30,
                                    text: { text: '00:00:00', fontSize: 24, fontFace: "Light" }
                                }
                            },
                            Progressbar: {
                                w: 366,
                                type: ProgressBar,
                                progress: 25,
                                style: {
                                    height: 8,
                                    barColor: 0xffffffff,
                                    progressColor: 0xffff0000,
                                    radius: 0
                                }
                            },
                        },
                        Playing: {
                            x: 20,
                            w: 172,
                            h: 42,
                            visible: false,
                            type: Badge, title: 'Now Playing', style: { paddingX: 12, paddingY: 10, strokeWidth: 3, radius: 0, backgroundColor: 0x00000000, strokeColor: 0xff91FC91, textStyle: { fontSize: 26, textColor: 0x99ffffff } }
                        }
                    },
                    Description: { y: 10, text: { text: 'description', fontSize: 24, fontFace: Helper.getFontFamily('Regular'), wordWrapWidth: 1200, maxLines: 2, maxLinesSuffix: '...', textOverflow: 'ellipsis', lineHeight: 47, letterSpacing: 0.5 } },
                }
            },
            EpgWrapper: {
                x: 0,
                y: 250,
                h: 288,
                w: 1920,
                ChannleNameWrapper: { //column
                    h: 288,
                    w: EPGConfig.ChannelWidth,
                    TimelineHeading: {
                        x: 0,
                        y: 0,
                        h: 72,
                        w: EPGConfig.ChannelWidth,
                        type: EPGProgramUI,
                        title: EPGUtility.displayToday(),
                    },
                    TimelineChannelHeading: {
                        x: 0,
                        y: 72,
                        h: 216,
                        clipping: true,
                        w: EPGConfig.ChannelWidth,
                        type: Column,
                        style: {
                            itemSpacing: 0
                        }
                    }
                },
                ChannleProgramWrapper: { //program
                    x: EPGConfig.ChannelWidth,
                    h: 288,
                    w: 1920 - EPGConfig.ChannelWidth,
                    clipping: true,
                    Timeline: {
                        x: 0,
                        y: 0,
                        h: 72,
                        w: 1920,
                        clipping:true,
                        type: EPGTimeRowUI,
                        zIndex: 2,
                        signals: {
                            'selectedChange': 'selectedChangeTimeline'
                        }
                    },
                    ChannelContainer: {
                        x: 0,
                        y: 72,
                        h: 216,
                        w: 1920,
                        clipping: true,
                        ChannelFocusManager: {
                            x: 0,
                            y: 0,
                            h: 216,
                            w: 1920,
                            type: Column,
                            style: {
                                itemSpacing: 0
                            }
                        },
                        CurrentTimeLineWrapper: {
                            x: 0,
                            y: 0,
                            h: 216,
                            zIndex: 8,
                            CurrTimeLine: {
                                x: 0,
                                rect: true,
                                w: 3,
                                h: 216,
                                color: 0xffff0000,
                            }
                        }
                    }
                }
            }
        }
    }

    static get __componentName(): string {
        return 'EPGGuide'
    }

    static get tags() {
        return ['TimelineChannelHeading', 'ChannelWrapper', 'ChannelFocusManager', 'Timeline']
    }

    static get properties() {
        return ['epg']
    }

    override _init() {
        this.focusTime = EPGUtility.getFocusTime()
    }

    override _detach() {
        this.stopAutoHideTimeout()
    }

    override _focus() {
        this.startAutoHideTimeout()
    }

    override _unfocus() {
        this.stopAutoHideTimeout()
    }

    startAutoHideTimeout() {
        this.stopAutoHideTimeout()
        this.autoHideId = setTimeout(() => {
            this.fireAncestors('$hideEpgGuide');
        }, this.autoHideTime)
    }

    stopAutoHideTimeout() {
        clearTimeout(this.autoHideId)
    }

    _update() {
        this._updateChannel()
    }

    _updateMetaData() {
        if (!this._epg) {
            return
        }

        if (this._epg && this.epgChannelCreated) {
            return
        }
    }

    _updateChannel() {
        if (!this._epg) {
            return
        }

        if (this._epg && this.epgChannelCreated) {
            return
        }
        this._updateTimeline(this._epg.timerange)
        //this._updateCurrentTime()
        const channelHeadderList = []
        const channelListUi = this._epg.EPGChannelList.map((channel: EpgChannel, index: number) => {
            channelHeadderList.push({
                y: index * 72,
                x: 0,
                w: EPGConfig.ChannelWidth,
                h: EPGConfig.ChannelRowHeight,
                rect: true,
                color: 0xff222222,
                type: Button,
                fixed: true,
                title: channel.name,
                zIndex: 10    
            })
            return {
                y:index * 72,
                w: 300,
                h: 72,
                type: EPGRowUI,
                title: channel.name,
                direction: 'row',
                //items: channel.createPrograms(this._epg.timerange, index),
                //selectedIndex: 5,
                channelIndex: index,
                channel: channel,
                timerange: this._epg.timerange,
                focusTime: this.focusTime,
                signals: {
                    'selectedChange': this.selectedChange.bind(this)
                },
                style: {
                    itemSpacing: 0
                }
            }
        })
        //console.log('channelListUi:,', channelListUi)
        this._TimelineChannelHeading.items = channelHeadderList
        this._TimelineChannelHeading.selectedIndex = this._epg.currIndex
        this._ChannelFocusManager.items = channelListUi
        this._ChannelFocusManager.selectedIndex = this._epg.currIndex
        this.epgChannelCreated = true;
    }

    _updateTimeline(timerange) {
        const channel = new EpgChannel()
        this._Timeline.items = channel.createTimeline(timerange)
    }

    _updateCurrentTime(currDate) {
        if (!this._epg) {
            return
        }
        let pos = EPGUtility.getCurrentTimelinePosition(this._epg.timerange, EPGConfig.pixelPerHour, currDate)
        this.tag('CurrTimeLine').x = pos

    }

    selectedChangeTimeline(selected) {
       // console.log('selectedChangeTimeline', selected.index, selected.x, selected.st)
        const transitionX = selected.x
        this.updateTransition(transitionX, selected)
    }

    $onRight() {
        this.tag('Timeline').selectNext()
    }

    $onLeft() {
        this.tag('Timeline').selectPrevious()
    }

    selectedChange(selected) {
        if (selected.channelIndex == selected.parent.parent.parent.parent.selectedIndex) {
           // console.log('selected : ', selected)
            const currIndex = selected.channelIndex
            const oldIndex = this.prevIndex
            this.updateInfo(selected)
            this._TimelineChannelHeading.selectedIndex = currIndex
            this._epg.currIndex = currIndex
            this.prevIndex = currIndex
            this.startAutoHideTimeout()
            setTimeout(() => {
                this._epg.getNextPrefetchingIndex(currIndex, oldIndex)
            },0)
        }
    }

    updateEpgChannel(selected) {
        if(this._epg && this._epg.currIndex) {
            this._ChannelFocusManager.selectedIndex = this._epg.currIndex
        }
    }

    updateInfo(selected) {
        setTimeout(() => {
            this.tag('Title').text.text = selected.title
            this.tag('ProgStartTime').text.text = EPGUtility.formatAMPM(selected.st)
            this.tag('ProgEndTime').text.text = EPGUtility.formatAMPM(selected.et)
            this.tag('Description').text.text = selected.description
            const isPlaying = EPGUtility.isPlaying(selected.st, selected.et, this._epg.currDate)
            this.tag('Playing').visible = isPlaying
            const dur = selected.et - selected.st
            const cur = this._epg.currDate - selected.st
            let perc = Math.max(cur / dur, 0)
            perc = Math.min(perc, 1)
            this.tag('Progressbar').progress = perc
            setTimeout(() => {
                this.updateImage(selected.image)
            },0)
        },0)
    }

    updateImage(url) {
        this.tag('Image').patch({
            Img: undefined
        })
        this._imgUrl = url
        clearTimeout(this.imageUpdateId)
        this.imageUpdateId = setTimeout(() => {
            this.tag('Image').patch({
                Img: {
                    w: 448,
                    h: 250,
                    src: getImage(this._imgUrl)
                }
            })
        }, 500)
    }

    async updateTransition(transitionX, selected) {
        const pos = (transitionX * -1)
        
        if (pos > 0) return
        this.focusTime = EPGUtility.getFocusTime(selected.st)
        this.focusTime.setMinutes(this.focusTime.getMinutes()+15)
        this.tag('CurrentTimeLineWrapper').setSmooth('x', pos);
        this._ChannelFocusManager.items.map((channel: EPGRowUI) => {
            if(channel.channelIndex !== selected.channelIndex) {
                channel.focusTime = this.focusTime
            }
            channel._Items.setSmooth('x', pos);
        })
        //this._ChannelFocusManager._Items.setSmooth('x', pos);
        this._Timeline._Items.setSmooth('x', pos);
    }

    override _handleEnter() {
        const selected: EPGRowUI = this._ChannelFocusManager.selected
        const program: EPGProgramUI = selected.selected
        const isPlaying = EPGUtility.isPlaying(program.st, program.et, this._epg.currDate)
        //console.log('EPG _handleEnter', selected, program, isPlaying)
        //if(isPlaying) {
        this.fireAncestors('$changeChannel', selected._channelIndex)
        //}
    }

    override _getFocused() {
        return this._ChannelFocusManager
    }
}
